import _ from 'lodash';
import { CONFIGURE_FILTERS, REMOVE_FILTERS } from './action-types';


export default function filters(state = { config: { showAdvancedFilters: false } }, action) {
  const filterState = _.assign({}, state);

  switch (action.type) {
    case CONFIGURE_FILTERS:
      filterState.config = _.assign({}, filterState.config, action.config);
      break;
    case REMOVE_FILTERS:
      filterState.config = {};
      break;
    default:
      return state;
  }

  return filterState;
}



// WEBPACK FOOTER //
// ./app/modules/filters/store/reducers.js